/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesStoreYandexGamesPurchaseRequest interface.
 */
export function instanceOfFxIdWebFeaturesStoreYandexGamesPurchaseRequest(value) {
    if (!('YandexGetPurchasesRequest' in value) || value['YandexGetPurchasesRequest'] === undefined)
        return false;
    if (!('YandexSignedData' in value) || value['YandexSignedData'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreYandexGamesPurchaseRequestFromJSON(json) {
    return FxIdWebFeaturesStoreYandexGamesPurchaseRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreYandexGamesPurchaseRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'YandexGetPurchasesRequest': json['YandexGetPurchasesRequest'],
        'YandexSignedData': json['YandexSignedData'],
    };
}
export function FxIdWebFeaturesStoreYandexGamesPurchaseRequestToJSON(json) {
    return FxIdWebFeaturesStoreYandexGamesPurchaseRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreYandexGamesPurchaseRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'YandexGetPurchasesRequest': value['YandexGetPurchasesRequest'],
        'YandexSignedData': value['YandexSignedData'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreYandexGamesPurchaseRequest.js.map